import { Box, BoxProps, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

interface IItemDetailsProps extends BoxProps {
  title: string
  value?: string | number | ReactNode
}
const ItemDetails = ({ value, title, ...rest }: IItemDetailsProps) => {
  return (
    <Box alignItems="center" display="flex" gap={2} {...rest}>
      <Typography
        sx={{
          fontFamily: 'Nunito',
          fontWeight: 700,
          opacity: 0.8,
          fontStyle: 'italic',
        }}
      >
        {title}:
      </Typography>
      {React.isValidElement(value) ? (
        value
      ) : (
        <Typography
          sx={{
            fontFamily: 'Nunito',
          }}
          fontWeight={600}
        >
          {value}
        </Typography>
      )}
    </Box>
  )
}

export default ItemDetails
